export const ELEMENT_UL = 'ul';
export const ELEMENT_OL = 'ol';
export const ELEMENT_LI = 'li';
export const ELEMENT_LIC = 'lic';

export const KEYS_LIST = [ELEMENT_UL, ELEMENT_OL, ELEMENT_LI, ELEMENT_LIC];
